// Filter: a missed tactic is only an opportunity when the alternative did not
// already win. If the second-best line wins decisively, taking the "chance"
// changes nothing, and a missed mate with a +12 alternative is not a lesson.
import { winProbability } from './win-probability.ts';

export const DECISIVE = 0.9;

/** The second-best line's score in centipawns from the reader's side. */
export function isRealOpportunity(second: number | undefined): boolean {
  return second === undefined || winProbability(second) < DECISIVE;
}
